import { render, staticRenderFns } from "./KeywordAnalytics.vue?vue&type=template&id=89eb7a50&scoped=true"
import script from "./KeywordAnalytics.vue?vue&type=script&lang=js"
export * from "./KeywordAnalytics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89eb7a50",
  null
  
)

export default component.exports